module.exports = __webpack_public_path__ + "img/default-ESC.408dd174.svg";